export const CursorDirections = {
    forward: 'forward',
    backward: 'backward',
};
export const SortDirections = {
    asc: 'asc',
    desc: 'desc',
};
export function applyCursor(base, input) {
    let q = base;
    if (input.cursor) {
        // the cursor must contain all fields that are sortable
        // even if you only sort by one of them
        const { direction: _direction, ...cursorFields } = input.cursor;
        q = q.start({ ...cursorFields });
    }
    if (input.limit) {
        q = q.limit(input.limit);
    }
    const way = input.cursor?.direction || 'forward';
    const sortField = input.sort?.field || 'createdAt';
    const sortDir = input.sort?.dir || 'desc';
    // if we go forward, then we use the sort direction set by the user (i.e. scrolling down)
    // if we go backwards, we sort in the other way selected by the user (i.e. scrolling up)
    const direction = way === 'forward' ? sortDir : sortDir === 'asc' ? 'desc' : 'asc';
    q = q.orderBy(sortField, direction).orderBy('id', direction);
    // the cursor only changes the sort/limit, not the table, relations or pinned-column set
    return q;
}
//# sourceMappingURL=apply-cursor.js.map